import { render, staticRenderFns } from "./videoPlay.vue?vue&type=template&id=06e1c988&"
import script from "./videoPlay.vue?vue&type=script&lang=js&"
export * from "./videoPlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports